import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

import auth from './auth.store';
import user from './user.store';
import portalTechnology from './technology.portal.store';
import portalEnterprise from './enterprise.portal.store';
import portalExpert from './expert.portal.store';
import portalMeans from './means.portal.store';
import portalNews from './news.portal.store';
import portalReport from './report.portal.store';
import portalPolicy from './policy.portal.store';
import portalHome from './home.portal.store';
import portalTrade from './trade.portal.store';
import portalServer from './server.portal.store';
import platform from './platform.portal.store';
import portalQuotation from './quotation.portal.store';

export default new Vuex.Store({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    auth,
    user,
    platform,
    portalTechnology,
    portalEnterprise,
    portalExpert,
    portalMeans,
    portalNews,
    portalReport,
    portalPolicy,
    portalHome,
    portalTrade,
    portalServer,
    portalQuotation,
  }
})
